import { pdfjs } from 'react-pdf';

// Set up the worker for PDF.js
// More reliable approach that works in development and production
// PDF.js v4.8.69 uses .mjs extension for worker files
let workerSrc: string;

// Process.env.PUBLIC_URL is defined by Create React App
// This approach works with both development and production builds
if (process.env.NODE_ENV === 'production') {
  // In production, use a public path
  workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;
} else {
  // In development, dynamically import from node_modules
  try {
    workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.mjs',
      import.meta.url
    ).toString();
  } catch (error) {
    // Fallback to a basic path
    workerSrc = '/pdf.worker.min.mjs';
  }
}

// Initialize worker immediately when this module is imported
pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

// Also export as a function in case it needs to be called explicitly
export const setupPdfWorker = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
};

export default setupPdfWorker;
